import * as types from "./Constants"
export const sendReportOtp = () => ({
  type: types.SEND_REPORT_OTP
})

export const sendReportOtpSuccess = (payload) => ({
  type: types.SEND_REPORT_OTP_SUCCESS,
  payload
})

export const sendReportOtpFailed = (payload) => ({
  type: types.SEND_REPORT_OTP,
  payload
})

export const verifyReportOtp = (payload) => ({
  type: types.VERIFY_REPORT_OTP,
  payload
})

export const verifyReportOtpSuccess = (payload) => ({
  type: types.VERIFY_REPORT_OTP_SUCCESS,
  payload
})

export const verifyReportOtpFailed = (payload) => ({
  type: types.VERIFY_REPORT_OTP_FAILED,
  payload
})

export const resetVerifyReport = () =>({
  type: types.RESET_VERIFY_REPORT
})